export const streamingCompleteEvent =
  'universal_help_live_answers_frontend_streaming_complete';

export const streamingFailedEvent =
  'universal_help_live_answers_frontend_streaming_failed';

export const uiRenderingCompleteEvent =
  'universal_help_live_answers_frontend_ui_rendering_complete';

export const inlineDataDoneCalled =
  'universal_help_live_answers_frontend_inline_data_done_called';

export const sourcesOpenedActionEvent =
  'universal_help_live_answers_frontend_sources_opened';

export const sourcesClosedActionEvent =
  'universal_help_live_answers_frontend_sources_closed';

export const answerFeedback = 'universal_help_live_answers_frontend_feedback';

export const sourcesLinkClickedActionEvent =
  'universal_help_live_answers_frontend_sources_link_clicked';

export const inlineLinkClickedActionEvent =
  'universal_help_live_answers_frontend_inline_link_clicked';

export const aiDisclaimerShownEvent =
  'universal_help_live_answers_frontend_ai_disclaimer_shown';
